import { render } from "./DetalharQuestaoAvaliacao.vue?vue&type=template&id=3fcfc540&scoped=true"
import script from "./DetalharQuestaoAvaliacao.vue?vue&type=script&lang=js"
export * from "./DetalharQuestaoAvaliacao.vue?vue&type=script&lang=js"

import "./DetalharQuestaoAvaliacao.vue?vue&type=style&index=0&id=3fcfc540&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcfc540"]])

export default __exports__